import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Avatar, Box, Card, CardHeader, Divider, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { cyan, red } from '@mui/material/colors';
import { size } from 'lodash';
import React, { Component } from 'react';
import Currency from '../../../common/Currency';

class SessionDetails extends Component {
    state = {
        openDemandList: "",
    }
    getDemandsList = () => {
        const { DEMANDS, EMPLOYEES, USERS, EQUIP } = this.props;
        console.log('====================================');
        console.log("LOAN LIST : ",{DEMANDS});
        console.log('====================================');
        let list = DEMANDS && DEMANDS.filter( demand => demand.demand_article === this.state.openDemandList )
        let history = list.map( demand => 
                <ListItem >
                    <ListItemText 
                        primary={
                            <Typography variant="body1">
                                {EMPLOYEES[demand.demand_employee].employee_firstname} {EMPLOYEES[demand.demand_employee].employee_lastname}
                            </Typography>
                        } 
                        secondary={demand.demand_remarks}
                    />
                        <ListItemSecondaryAction>
                            <ListItemText secondary={
                                <Typography variant="h6" color="primary">
                                    x {demand.demand_quantity}
                                </Typography>
                            } />
                        </ListItemSecondaryAction>
                    </ListItem>
                )
       
        return history
    }

    render() {
        const { session, USERS, ARTICLES, DEMANDS, stats } = this.props;
        const { openDemandList } = this.state;
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                            Créée par : 
                            <Typography variant="button" >
                                <b> {USERS[session.session_creator].lastname}  {USERS[session.session_creator].username}</b>
                            </Typography>
                        </Box>
                        <Divider />
                        <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                            Date de publication : 
                            <b> {session.session_validate ? new Date(session.session_publication_date).toLocaleDateString("fr-FR") : " - "}</b>
                        {/* <Typography variant="button" > */}
                        {/* </Typography> */}
                        </Box>
                        <Divider />
                        <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                            Date de fin : 
                            <b> {session.session_is_over ? new Date(session.session_end_date).toLocaleDateString("fr-FR") : " - "}</b>
                        {/* <Typography variant="button" > */}
                        {/* </Typography> */}
                        </Box>
                        <Divider />
                        <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                            Nombre d'employés participants: 
                            <b> {stats.nbEmployee}</b>
                        </Box>
                        <Divider />
                        <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                            Nombre de demandes total: 
                            <b> {size(DEMANDS)}</b>
                        </Box>
                        <Divider />
                        <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                            Prix total: 
                            <b> <Currency value={stats.totalPrice} /></b>
                        </Box>
                        <Divider />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Card>
                            <CardHeader 
                                subheader="Liste des articles" 
                            />
                                
                            <Box p={2}>
                                <List>
                                    {session.session_articles.split(", ").map((art, i) =>
                                    <>
                                        <ListItem 
                                            alignItems="flex-start"
                                            // secondaryAction={
                                            //     // <Currency value={ARTICLES[art].article_price} />
                                                
                                            // }
                                            style={{background:(i % 2 === 0 ? "rgb(224 247 250 / 60%)" : "white")}}
                                            key={ARTICLES[art].article_id}
                                        >
                                            <ListItemAvatar>
                                                <Avatar variant="rounded" alt={ARTICLES[art].article_name} src={`/photos/single/${ARTICLES[art].article_photo.filename}`} />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={
                                                    <React.Fragment>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="h6"
                                                            color="text.primary"
                                                        >
                                                            {ARTICLES[art].article_name}
                                                        </Typography>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body1"
                                                            color="text.secondary"
                                                        >
                                                            {" "}{ARTICLES[art].article_brand}
                                                        </Typography>
                                                                                                                
                                                    </React.Fragment>
                                                }
                                                secondary={
                                                    <React.Fragment>
                                                        <Typography
                                                            sx={{ display: 'inline' }}
                                                            component="span"
                                                            variant="body2"
                                                            color="text.primary"
                                                        >
                                                            <Currency value={ARTICLES[art].article_price} />
                                                        </Typography>
                                                        {/* {" "}{ARTICLES[art].article_desc} */}
                                                        {" "}{ARTICLES[art].article_remarks}
                                                    </React.Fragment>
                                                }
                                            />
                                            <IconButton
                                                onClick={ () => this.setState({
                                                    openDemandList: openDemandList === art ? "" : art
                                                }) }
                                                size="large"
                                            >
                                                {openDemandList === art ? <ExpandLess /> : <ExpandMore />}

                                            </IconButton>
                                        </ListItem>
                                        {openDemandList === art &&
                                            this.getDemandsList()
                                        }
                                    </>
                                    )}
                                    
                                </List>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>

            </Box>
        );
    }
}

export default SessionDetails;